import React, { FC } from 'react';

interface IComponentProps {
  label: string;
  value: React.ReactNode;
  color?: string;
}

export const DescriptionsRow: FC<IComponentProps> = ({ label, value, color }) => {
  return (
    <div className="descriptions-row">
      <div className="ff-regular fs-s" style={{ color: color ?? '#808a94' }}>
        {label}
      </div>
      <div className="ff-regular fs-s" style={{ color: color ?? '#2f3337' }}>
        {value}
      </div>
    </div>
  );
};
